import React, { useState, useEffect } from 'react';
import { useFileContext } from '../../ContextAPI/FileContext';
import './ToggleSwitch.css';
import { ManagerlApi } from '../../API/api';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { FaTrash } from 'react-icons/fa';

const CarRemovalTab = () => {
  const { setRunCarRemoval } = useFileContext();
  const [tilesFolder, setTilesFolder] = useState('');
  const [groundFolder, setGroundFolder] = useState('');
  const [nongroundFolder, setNongroundFolder] = useState('');
  const [roadDetectionFolder, setRoadDetectionFolder] = useState('');
  const [showCheckMark, setShowCheckMark] = useState(false);
  const [requests, setRequests] = useState([]);


  const getFormattedTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleRunCarRemoval = async () => {
    const apiUrl = `${ManagerlApi}/car-removal/`;

    const requestData = {
      tiles_folder: tilesFolder,
      ground_folder: groundFolder,
      nonground_folder: nongroundFolder,
      road_detection_folder: roadDetectionFolder,
    };

    setShowCheckMark(false);
    setTimeout(() => {
      setShowCheckMark(true);
      setTimeout(() => setShowCheckMark(false), 6000);
    }, 100);

    const startTime = getFormattedTime();
    const requestId = uuidv4();
    setRequests((prevRequests) => [
      ...prevRequests,
      {
        id: requestId,
        roadDetectionFolder,
        status: 'Sent',
        startTime,
        inputs: requestData,
        showInputs: false,
      },
    ]);

    try {
      const response = await axios.post(apiUrl, requestData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const statusMessage = response.data.message || 'Task Completed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${statusMessage} ✅` }
            : request
        )
      );
    } catch (error) {
      console.error('There was an error running Car Removal!', error);

      const errorMessage = error.response?.data?.message || 'Task Failed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${errorMessage} ❌` }
            : request
        )
      );
    }
  };

  const toggleInputsVisibility = (id) => {
    setRequests((prevRequests) =>
      prevRequests.map((request) =>
        request.id === id ? { ...request, showInputs: !request.showInputs } : request
      )
    );
  };

  const handleDeleteRequest = (id) => {
    setRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== id)
    );
  };

  const handleClearAll = () => {
    setRequests([]);
  };

  useEffect(() => {
    setRunCarRemoval(() => handleRunCarRemoval);
  }, [setRunCarRemoval]);

  return (
    <div>
      <div>
        <label>Tiles Folder</label>
        <input
          type='text'
          placeholder='Tiles Folder ID'
          value={tilesFolder}
          onChange={(e) => setTilesFolder(e.target.value)}
        />
      </div>
      <div>
        <label>Ground Folder</label>
        <input
          type='text'
          placeholder='Ground Folder ID'
          value={groundFolder}
          onChange={(e) => setGroundFolder(e.target.value)}
        />
      </div>
      <div>
        <label>Non-Ground Folder</label>
        <input
          type='text'
          placeholder='Non-Ground Folder ID'
          value={nongroundFolder}
          onChange={(e) => setNongroundFolder(e.target.value)}
        />
      </div>
      <div>
        <label>Road Detection Folder</label>
        <input
          type='text'
          placeholder='Road Detection Folder ID'
          value={roadDetectionFolder}
          onChange={(e) => setRoadDetectionFolder(e.target.value)}
        />
      </div>
      <div>
        <button onClick={handleRunCarRemoval}>
          Run Car Removal
        </button>
      </div>
      {showCheckMark && (
        <div className='check-mark'>Request {roadDetectionFolder} Sent ✅</div>
      )}
      <div className='request-list'>
        <table>
          <thead>
            <tr>
              <th>Request ID</th>
              <th>Status</th>
              <th>Start Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <React.Fragment key={request.id}>
                <tr>
                  <td>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'inherit',
                        textDecoration: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => toggleInputsVisibility(request.id)}
                    >
                      {request.id}
                    </button>
                  </td>
                  <td>{request.status}</td>
                  <td>{request.startTime}</td>
                  <td>
                    <button onClick={() => handleDeleteRequest(request.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
                {request.showInputs && (
                  <tr>
                    <td colSpan={4}>
                      <pre>{JSON.stringify(request.inputs, null, 2)}</pre>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <button className='clear-all-button' onClick={handleClearAll}>
          Remove All
        </button>
      </div>
    </div>
  );
};

export default CarRemovalTab;
